import type { PaginationParams } from '../types/Pagination.types';
import { z } from 'zod';
import { MediaDtoSchema } from '../media/media.schema';
import { PageContentDtoSchema } from '../system-pages';
import { PaginationParamsSchema } from '../types/Pagination.types';

export const ProviderDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  order: z.number(),
  // null | undefined | MediaDto
  cover: MediaDtoSchema.nullish(),
  mobileCover: MediaDtoSchema.nullish(),
  desktopCover: MediaDtoSchema.nullish(),
  mobileListCover: MediaDtoSchema.nullish(),
  description: z.string().nullish(),
  isActive: z.boolean(),
  alias: z.string(),
  isLicenceActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  settings: z.object({
    allow: z.string().optional(),
  }).nullable().optional(),
  pageContent: PageContentDtoSchema.nullish(),
});

const StringFilterSchema = z.union([
  z.string(),
  z.object({
    $cont: z.string().optional(),
    $ne: z.string().optional(),
  }),
]);
export const ProviderFiltersSchema = z.object({
  name: StringFilterSchema.optional(),
  isActive: z.boolean().optional(),
}).optional();

export const ProviderParamsSchema = PaginationParamsSchema(ProviderFiltersSchema);

export type ProviderDto = z.infer<typeof ProviderDtoSchema>;
export interface ProviderListDto extends z.infer<typeof ProviderDtoSchema> {}

export type ProviderListParams = PaginationParams<typeof ProviderParamsSchema>;
